
import { Component, Prop, Vue } from "vue-property-decorator"

export interface ToolbarButton {
	key: string
	icon: string
	label: string
	tooltip: string
	variant?: "primary" | "secondary" | "danger" | "warning" | "success" | "info"
	disabled?: boolean
}

@Component({})
export default class Toolbar extends Vue {
	@Prop({ type: Array, default: () => [] })
	buttons!: ToolbarButton[]

	@Prop({ type: Boolean, default: false })
	collapsed!: boolean

	@Prop({ type: Boolean, default: false })
	allowCollapse!: boolean
}
